<div *ngIf="userInfo" class="user header-account" [class.header-account--secondary]="hasSecondaryName">

  <!-- ── Trigger ── -->
  <button
    id="userDropdown"
    type="button"
    class="user-menu-trigger"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="menu"
    (click)="toggleDropdown()"
  >
    <span class="user-menu-trigger__avatar">
      <i class="material-icons">person_outline</i>
    </span>

    <span class="user-menu-trigger__content">
      <span class="user-menu-trigger__primary">{{ primaryNameDisplay }}</span>
      <span *ngIf="secondaryNameDisplay" class="user-menu-trigger__secondary">
        {{ secondaryNameDisplay }}
      </span>
    </span>

    <i class="material-icons user-menu-trigger__chevron"
       [class.user-menu-chevron-open]="hasInteracted && isOpen"
       [class.user-menu-chevron-closed]="hasInteracted && !isOpen">
      expand_more
    </i>
  </button>

  <!-- ── Painel ── -->
  <div *ngIf="isOpen"
       class="header-account-dropdown"
       role="menu"
       aria-labelledby="userDropdown"
       [class.header-account-dropdown--open]="!isClosing"
       [class.header-account-dropdown--closing]="isClosing">

    <!-- Perfil -->
    <div class="header-account-dropdown__section header-account-dropdown__section--profile">
      <p class="header-account-dropdown__title">{{ displayedMenuTitle }}</p>

      <p *ngIf="displayedOrganizationName" class="header-account-dropdown__subtitle">
        {{ displayedOrganizationName }}
      </p>

      <div class="header-account-dropdown__user-row">
        <i class="material-icons"></i>
        <span>{{ userInfo.name }}</span>
      </div>

    </div>

    <!-- Links rápidos -->
    <div *ngIf="quickLinks.length" class="header-account-dropdown__quick-links">
      <p class="header-account-dropdown__label">Links rápidos</p>

      <div *ngFor="let link of quickLinks; let i = index; trackBy: trackByIndex"
           class="quick-link-item">
        <span class="quick-link-item__label">{{ link.label }}</span>

        <button type="button"
                class="quick-link-item__copy user-menu-copy-btn"
                [attr.aria-label]="'Copiar link de ' + link.label"
                (click)="copyQuickLink(link, i)">

          <!-- Ícone alterna entre "done" e "content_copy" -->
          <span class="quick-link-item__icon"
                [class.user-menu-check-pop]="copiedIndex === i">
            <i class="material-icons">{{ copiedIndex === i ? 'done' : 'content_copy' }}</i>
          </span>

          <!-- Tooltip permanece no DOM para a animação de saída funcionar -->
          <span class="quick-link-item__tooltip"
                [style.display]="copiedIndex === i || hidingIndex === i ? 'block' : 'none'"
                [class.user-menu-tooltip-enter]="copiedIndex === i && hidingIndex !== i"
                [class.user-menu-tooltip-exit]="hidingIndex === i">
            Copiado!
          </span>
        </button>
      </div>
    </div>

    <!-- Compradores / Vendedores -->
    <ng-container *ngIf="hasOemDealerGroup() || hasDealerGroup()">
      <div class="header-account-dropdown__section">

        <!-- Abas -->
        <div class="user-menu-tabs"
             [class.user-menu-tabs--single]="!(hasDealerGroup() && hasOemDealerGroup())">

          <button *ngIf="hasDealerGroup()"
                  type="button"
                  class="user-menu-tab"
                  [class.user-menu-tab--active]="optionSelected === 'DEALER'"
                  (click)="selectTab('DEALER')">
            Compradores
          </button>

          <button *ngIf="hasOemDealerGroup()"
                  type="button"
                  class="user-menu-tab"
                  [class.user-menu-tab--active]="optionSelected === 'OEM_DEALER'"
                  (click)="selectTab('OEM_DEALER')">
            Vendedores
          </button>
        </div>

        <!-- Busca -->
        <div class="user-menu-search-wrapper">
          <i class="material-icons user-menu-search-wrapper__icon">search</i>
          <input type="text"
                 class="user-menu-search"
                 placeholder="Buscar"
                 [(ngModel)]="search"
                 (ngModelChange)="filterDealers($event)" />
        </div>

        <!-- Lista OEM (Vendedores) -->
        <div *ngIf="optionSelected === 'OEM_DEALER'" class="user-menu-entities">
          <button type="button"
                  class="user-menu-item"
                  [class.user-menu-item--active]="userInfo.oemDealerGroupSelected === null"
                  (click)="onClickOemDealers(null)">
            <span>Visão consolidada</span>
            <i *ngIf="userInfo.oemDealerGroupSelected === null" class="material-icons">done</i>
          </button>

          <button *ngFor="let oem of filteredOemDealers"
                  type="button"
                  class="user-menu-item"
                  [class.user-menu-item--active]="isOemDealerSelected(oem)"
                  (click)="onClickOemDealers(oem)">
            <span>{{ oem.name }}</span>
            <i *ngIf="isOemDealerSelected(oem)" class="material-icons">done</i>
          </button>
        </div>

        <!-- Lista Dealers (Compradores) -->
        <div *ngIf="optionSelected === 'DEALER'" class="user-menu-entities">
          <button *ngFor="let dealer of filteredDealers"
                  type="button"
                  class="user-menu-item"
                  [class.user-menu-item--active]="isDealerSelected(dealer)"
                  (click)="onClickDealers(dealer)">
            <span>{{ dealer.name }}</span>
            <i *ngIf="isDealerSelected(dealer)" class="material-icons">done</i>
          </button>
        </div>

      </div>
    </ng-container>

    <!-- Rodapé -->
    <div class="header-account-dropdown__footer">
      <a [routerLink]="['/logout']"
         class="header-account-dropdown__logout user-menu-logout"
         (click)="closeDropdown(true)">
        <i class="material-icons">logout</i>
        <span>Sair</span>
      </a>
    </div>

  </div>
</div>
